import { CANADA_COUNTRY_CODE, TERMS_LAST_YEAR, US_COUNTRY_CODE } from '../helpers/constants'
import { API } from './../api/api'
import { fetch } from './../api/httpClient'
import { get } from './../helpers/utils'
import ActionTypes from './actionTypes'

export const countriesCall = (pageDetail, successCallback, errorCallback) => async (dispatch) => {
  const apiPathAllCountries = `${API.MDS}api/countries?sort_by=${pageDetail.sort_by}&sort_order=${pageDetail.sort_order}&per_page=${pageDetail.per_page}&page=${pageDetail.page}&q=${pageDetail.q}`
  try {
    let { data } = await fetch(apiPathAllCountries)
    let countries = get(data, 'content', [])
    dispatch({
      type: ActionTypes.MASTER,
      data: {
        countries,
      },
    })
    if (typeof successCallback === 'function') {
      successCallback({ countries })
    }
  } catch (err) {
    if (typeof errorCallback === 'function') {
      errorCallback(err)
    }
  }
}

export const countriesByOrgCall = (schoolUrn, successCallback, errorCallback) => async () => {
  const apiPathUrnCountries = `${API.MDS}api/mds/${btoa(schoolUrn)}/countries`
  try {
    let { data = [] } = await fetch(apiPathUrnCountries)
    data = data
      .map((item) => item.data)
      .sort((a, b) => {
        return a.iso === US_COUNTRY_CODE || a.iso === CANADA_COUNTRY_CODE
          ? -1
          : b.iso === US_COUNTRY_CODE || b.iso === CANADA_COUNTRY_CODE
          ? 1
          : 0
      })

    if (typeof successCallback === 'function') {
      successCallback(data)
    }
  } catch (err) {
    if (typeof errorCallback === 'function') {
      errorCallback(err)
    }
  }
}

export const statesCall = (countryCode, pageDetail, successCallback, errorCallback) => async () => {
  const apiPathAllStates = `${API.MDS}api/countries/${countryCode}/state?sort_by=${pageDetail.sort_by}&sort_order=${pageDetail.sort_order}&per_page=${pageDetail.per_page}&page=${pageDetail.page}&q=${pageDetail.q}`
  try {
    let { data } = await fetch(apiPathAllStates)
    if (typeof successCallback === 'function') {
      successCallback(data)
    }
  } catch (err) {
    if (typeof errorCallback === 'function') {
      errorCallback(err)
    }
  }
}

export const masterDataCall = (successCallback, failureCallback) => async (dispatch) => {
  try {
    let { data } = await fetch(API.CORE.MASTER)
    Object.keys(data).forEach((item) => {
      if (item === 'enrollment_status') {
        data[item] = Object.keys(data[item]).filter((obj) => obj !== 'pending_payment')
      } else if (item === 'additional_fee') {
        data[item] = Object.keys(data[item]).map((fee) => ({
          key: fee,
          ...JSON.parse(data[item][fee]),
        }))
      } else if (item === 'email_names') {
        data[item] = Object.keys(data[item]).map((email) => ({
          ...JSON.parse(data[item][email]),
        }))
      } else {
        data[item] = Object.keys(data[item])
      }
    })
    let terms = Array.from({ length: TERMS_LAST_YEAR + 1 }, (_, index) => index)
    for (let i = 0; i < terms.length - 1; i++) {
      const currValue = terms[i]
      const nextValue = terms[i + 1]
      terms[i] = `${i < 10 ? `0${currValue}` : currValue}/${
        i + 1 < 10 ? `0${nextValue}` : nextValue
      }`
    }
    terms.pop()
    data.terms = terms
    dispatch({
      type: ActionTypes.MASTER,
      data,
    })
    if (typeof successCallback === 'function') {
      successCallback()
    }
  } catch (error) {
    if (typeof failureCallback === 'function') {
      failureCallback(error)
    }
  }
}

export const ethnicityCall = (successCallback, failureCallback) => async () => {
  try {
    let { data } = await fetch(`${API.MDS}api/ethnicity`)
    if (typeof successCallback === 'function') {
      successCallback(data)
    }
  } catch (error) {
    if (typeof failureCallback === 'function') {
      failureCallback(error)
    }
  }
}
